import type { CallbackPayload } from './shared/type';

/**
 * Registers the callback the visitor scheduled against their lead. Throws on a rejected
 * response so the scheduler keeps the visitor on the confirmation step with a retry, rather
 * than claiming a call that was never booked.
 */
export async function submitCallback(leadId: number, schedule: CallbackPayload): Promise<void> {
  const response = await fetch(`/api/v1/lead/${leadId}/callback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(schedule),
  });

  if (!response.ok) {
    throw new Error(`Failed to schedule the callback for lead ${leadId}`);
  }
}
